<template>
    <span>
        <button type="button" class="btn" @click="() => show_dialogs.send_cbr=true" :disabled="!oneRowSelected">Single-account CBR</button>
        <single-account-cbr-dialog :show="show_dialogs.send_cbr"
                                     :selected_employers="selected_employers"
                                     @close="show_dialogs.send_cbr = false"
        ></single-account-cbr-dialog>
    </span>
</template>

<script>
import SingleAccountCbrDialog from "./single-account-cbr-dialog";

export default {
    components: {SingleAccountCbrDialog},
    props: [
        'selected_employers'
    ],
    data() {
        return {
            show_dialogs: {
                send_cbr: false
            }
        };
    },
    computed: {
        oneRowSelected() {
            return this.selected_employers.length == 1;
        }
    }
}
</script>
